export const DEFAULT_SEO = {
  title: 'eOne Store',
  description: 'Tienda online B2B/B2C integrada con ERP Cloud',
  ogType: 'website',
  twitterCard: 'summary_large_image',
};
